import { createSelector } from 'reselect';
import get from 'lodash/get';
import {
  data as dataSelector,
  data2 as data2Selector,
  advWorkflow as advWorkflowSelector,
  currentClientId as currentClientIdSelector,
} from '../../../AdvWorkflow/AdvWorkflowSelector';
import { BACKEND_KEY } from '../../LargePurchaseWorkflowConstants';

export default createSelector(dataSelector, data2Selector, (data, data2) => {
  const key = `${BACKEND_KEY}.Cost`;

  return (data2(key) || data2(key) === '') ? data2(key) : data(key);
});

export const largePurchaseAmountOrDefaultSelector = createSelector(
  advWorkflowSelector,
  currentClientIdSelector,
  (advWorkflow, clientID) =>
    get(
      advWorkflow,
      `${clientID}.data2.${BACKEND_KEY}.Cost`,
      get(advWorkflow, `${clientID}.data.${BACKEND_KEY}.Cost`, ''),
    ),
);
